import { useTranslations } from 'next-intl';
import { MODEL_IMAGE_MAP, MODEL_VERSION, MODEL_VERSION_SETTINGS_MAP } from '@/app/constants';
import { useStore } from '@/app/providers/store';
import type { ConfigMap, FormSettingsKey, ModelVersion } from '@/app/types';
import { transformSettings } from '../_utils/transform-settings';

const Q2IconSrc = MODEL_IMAGE_MAP[MODEL_VERSION.Q2];

export const useSettings = () => {
  const t = useTranslations();

  const { remainingTrialsQ2Extend, remainingTrialsQ2ExtendPro } = useStore((state) => ({
    remainingTrialsQ2Extend: state.trialsQ2Extend?.remaining,
    remainingTrialsQ2ExtendPro: state.trialsQ2ExtendPro?.remaining,
  }));

  const toolsConfig: Partial<Record<'video2extend', Partial<Record<FormSettingsKey, ConfigMap>>>> = {
    video2extend: {
      settingsQ2: {
        transition: [
          {
            value: 'extendspeed',
            label: t('create.extendForm.modelSelection.q2-speed'),
            showVip: true,
            remainingTrials: remainingTrialsQ2Extend,
            icon: Q2IconSrc,
          },
          {
            value: 'extendpro',
            label: t('create.extendForm.modelSelection.q2-pro'),
            showVip: true,
            remainingTrials: remainingTrialsQ2ExtendPro,
            icon: Q2IconSrc,
          },
        ],
        duration: ['1', '2', '3', '4', '5', '6', '7'],
        amount: [
          '1',
          {
            value: '2',
            label: '2',
            showVip: true,
            subPlans: ['standard_v2', 'premium_v2', 'ultimate_v2', 'team_v2'],
          },
          {
            value: '3',
            label: '3',
            showVip: true,
            subPlans: ['standard_v2', 'premium_v2', 'ultimate_v2', 'team_v2'],
          },
          {
            value: '4',
            label: '4',
            showVip: true,
            subPlans: ['standard_v2', 'premium_v2', 'ultimate_v2', 'team_v2'],
          },
        ],
        resolution: ['1080p'],
      },
    },
  };

  const getSettings = (formType: 'video2extend', formVersion: ModelVersion) => {
    const configMap = toolsConfig[formType]?.[MODEL_VERSION_SETTINGS_MAP[formVersion]];
    if (configMap) {
      return transformSettings(configMap);
    }
    return undefined;
  };

  return {
    getSettings,
  };
};
